import React, { Component } from 'react';
import moment from 'moment';
import DraggableModal from 'components/Modal/DraggableModal';

import "./ModalCompanyDetailNews.scss"
import { FormattedDate } from 'components/Formating';
import { CommonUtils } from 'utils';
import memoizeOne from 'memoize-one';
import { FormattedMessage } from 'react-intl';
class ModalCompanyDetailNews extends Component {

    constructor(props) {
        super(props);
        this.TransAuthExternalRef = React.createRef();
    }

    initialState = {
    };

    state = {
        ...this.initialState
    };

    getFullContent = memoizeOne((value = "") => {
        value = value.replaceAll("\r", "")
        value = value.replaceAll("\n", "")
        value = value.replaceAll("\t", "")
        return value
    })

    render() {
        const { isOpen, toggle, dataFill } = this.props;
        return (
            <DraggableModal
                isOpen={isOpen}
                toggle={toggle}
                onClose={toggle}
                className='modal-company-detail-news'
                titleId={dataFill && dataFill.newstitle || ""}
            >
                <div className="body txt---500-14-20">
                    <div className="body-top text-not-active ">
                        <FormattedDate value={dataFill.publicdate} format={"DD-MM-YYYY | HH:mm"} />
                    </div>
                    <div className="body-content" >
                        <div className="content">
                            {(dataFill && dataFill.newsfullcontent)
                                ?
                                <div dangerouslySetInnerHTML={{ __html: this.getFullContent(dataFill.newsfullcontent) }}></div>
                                : <></>
                            }
                            {(dataFill && dataFill.newssourcelink) &&
                                <div className="link-ref" onClick={() => CommonUtils.openInNewTab(dataFill.newssourcelink)}>
                                    <span className="title text-near-active">
                                        <FormattedMessage id="company-news-symbol.newsOrigin" />
                                    </span>
                                </div>
                            }
                            {/* <iframe
                                id="id-iframe-detail-news"
                                src={dataFill.newssourcelink}
                                style={{ width: "100%", height: "500px", border: "none" }}
                                title="External Content"
                            /> */}
                        </div>
                    </div>
                </div>
            </DraggableModal>
        );
    }

}



export default ModalCompanyDetailNews;